import { type ReactNode } from "react";
import useWindowSize from "../../modules/helpers/windowSize";
import * as styles from "./styles.module.scss";

interface IProps {
  children: ReactNode;
}

const DefaultLayout = (props: IProps) => {
  const [width, height] = useWindowSize();

  return (
    <div className={styles.container} style={{ height, width }}>
      <main className={styles.innerContainer}>{props.children}</main>
    </div>
  );
};

export default DefaultLayout;
